interface ApiErrorPayload {
  code?: unknown;
  message?: unknown;
  failures?: unknown;
  rules?: {
    violations?: unknown;
  };
  details?: ApiErrorPayload;
}

const unique = (values: string[]): string[] => Array.from(new Set(values));

export const normalizeErrorMessage = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed.length ? trimmed : null;
};

export const getApiResponseData = (error: unknown): ApiErrorPayload | null => {
  const responseData = (error as any)?.response?.data;
  return responseData && typeof responseData === 'object'
    ? (responseData as ApiErrorPayload)
    : null;
};

export const getApiErrorPayload = (error: unknown): ApiErrorPayload | null => {
  const responseData = getApiResponseData(error);
  if (!responseData) return null;

  const details = responseData.details;
  return details && typeof details === 'object'
    ? (details as ApiErrorPayload)
    : responseData;
};

export const extractFailureMessages = (failures: unknown): string[] => {
  if (!Array.isArray(failures)) return [];

  const messages = failures
    .map((failure: any) => {
      const message = normalizeErrorMessage(failure?.message);
      const code = normalizeErrorMessage(failure?.code);
      return message || code;
    })
    .filter((message): message is string => Boolean(message));

  return unique(messages);
};

export const extractErrorDescription = (error: unknown): string | undefined => {
  const responseData = getApiResponseData(error);
  const errorPayload = getApiErrorPayload(error);
  if (!errorPayload) return undefined;

  const violationMessages = extractFailureMessages(
    errorPayload.rules?.violations
  );
  if (violationMessages.length > 0) {
    return violationMessages.join('\n');
  }

  const failureMessages = extractFailureMessages(errorPayload.failures);
  if (failureMessages.length > 0) {
    return failureMessages.join('\n');
  }

  const message =
    normalizeErrorMessage(errorPayload.message) ||
    normalizeErrorMessage(responseData?.message);
  return message || undefined;
};
